import { useEffect, useState } from 'react';

export const usePath = () => {
	const [currentPath, setCurrentPath] = useState<string>();

	useEffect(() => {
		setCurrentPath(window?.location.pathname.replace('/', ''));
	}, []);

	return currentPath;
};
